import React from "react"
import { Outlet } from "react-router-dom"

import Footer from "shared/components/Footer"
import Navigation from "shared/views/Navigation"

import styles from "../Layout.module.css"

export default function WithNav({ children }) {
  return (
    <section className={styles.withNav}>
      <Navigation />
      <div className={styles.main}>{children || <Outlet />}</div>
      <Footer />
    </section>
  )
}
